import { NgModule } from '@angular/core';
import { TimelineChartComponent } from './timeline-chart/timeline-chart.component';
import { SharedProviderModule } from '../../../shared/shared.module';
import { TooltipComponent } from './tooltip/tooltip.component';
import { QmDirectivesModule } from '../../../components/qm-directives/qm-directives.module';
import { TrainPersonnelModule } from '../train-personnel/train-personnel.module';

@NgModule({
  declarations: [TimelineChartComponent, TooltipComponent],
  imports: [
    QmDirectivesModule,
    SharedProviderModule,
    TrainPersonnelModule,
  ],
  exports: [TimelineChartComponent, TooltipComponent]
})
export class WorkshiftTimelineModule { }
